import {random, round2, round2Str} from "../helpers/helpers";

export const generateTransformerDemoData = (meterId) => {

    // Voltage Phase to Neutral
    const voltage = random(238, 242);

    // Power Factor
    const pf = random(0.85, 0.98);

    // Phase currents
    const currentR = random(250, 280);
    const currentY = random(245, 275);
    const currentB = random(255, 285);

    const totalCurrent = currentR + currentY + currentB;

    // kW = (V * I * PF * 3) / 1000
    const activePower = round2((voltage * totalCurrent * pf) / 1000);

    // kVA = (V * I * 3) / 1000
    const apparentPower = round2((voltage * totalCurrent) / 1000);

    const now = new Date();
    const formattedDate = `${now.getDate()}-${now.toLocaleString('default', {
        month: 'short',
    })}-${now.getFullYear().toString().slice(-2)} ${now
        .getHours()
        .toString()
        .padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;

    return {
        transformer_name: `Distribution Transformer (${meterId || "4141"})`,
        capacity: 2000,
        last_seen: formattedDate,

        // Electrical
        active_power: round2Str(activePower),
        apparent_power: round2Str(apparentPower),
        pf: round2Str(pf),

        current_load: round2Str((apparentPower / 2000) * 100),

        current_r: round2Str(currentR),
        current_y: round2Str(currentY),
        current_b: round2Str(currentB),

        volt_rn: round2Str(voltage),
        volt_yn: round2Str(voltage - random(0, 2)),
        volt_bn: round2Str(voltage + random(0, 1)),

        // Thermal
        oil_temp: round2Str(random(35, 42)),
        winding_temp: round2Str(random(38, 45)),
        max_oil_temp: "52.00",
        max_winding_temp: "54.00",

        // Status (true = healthy demo)
        buchholz_alarm_status: true,
        buchholz_trip_status: true,
        oil_surge_relay: true,
        magnetic_oil: true,
        fan: true,
        ot_alarm: true,
        ot_trip: false,
        wt_alarm: true,
        wt_trip: true,

        // Set Points
        ot_alarm_set_point: "80.00",
        ot_trip_set_point: "90.00",
        wt_alarm_set_point: "85.00",
        wt_trip_set_point: "95.00",
    };
};
